module.exports = __webpack_public_path__ + "static/img/decoration2.30946bb5.png";